import { EENV } from "./constants";

export const ENV = (process.env.REACT_APP_ENV || "production") as EENV;
export const API_HOST = process.env.REACT_APP_API_HOST || "";
export const API_PATH = `/api/opsnavi`;
export const LOGIN_URL = process.env.REACT_APP_LOGIN_URL || "";
export const MAIN_DOMAIN = process.env.REACT_APP_MAIN_DOMAIN || "";
export const MAIN_URL = process.env.REACT_APP_MAIN_URL || "";
export const OPSNAVI_URL = process.env.REACT_APP_OPSNAVI_URL || "";
export const SECRET_KEY = process.env.REACT_APP_SECRET_KEY || "";
export const IV_KEY = process.env.REACT_APP_IV_KEY || "";
export const SENTRY_DSN = process.env.REACT_APP_SENRTY_DSN || "";
